import React from "react";
import ModalButton from "../ModalButton";
import { WarningCircleIcon, XIcon } from "@phosphor-icons/react";
import {
  StyledPopup,
  HeadCard,
  Content,
  IconWrap,
  Title,
  Intro,
  BottomCard,
} from "../MarcaBlancaRequirementsModal/styles";

type Props = {
  open: boolean;
  color: string;
  title: string;
  message: string;
  acknowledgeLabel: string;
  onClose: () => void;
};

/**
 * Modal de datos protegidos del checkout de Marca Blanca. Se muestra cuando los
 * campos precargados fueron manipulados en el cliente y no coinciden con la
 * validación del backend.
 */
const MarcaBlancaTamperModal: React.FC<Props> = ({
  open,
  color,
  title,
  message,
  acknowledgeLabel,
  onClose,
}) => {
  return (
    <StyledPopup
      open={open}
      modal
      closeOnDocumentClick={false}
      closeOnEscape={false}
      onClose={() => undefined}
    >
      <div className="container">
        <HeadCard>
          <XIcon
            size={24}
            color="#999999"
            style={{ cursor: "pointer" }}
            onClick={onClose}
          />
        </HeadCard>

        <Content>
          <IconWrap>
            <WarningCircleIcon size={56} weight="regular" color="#F5C518" />
          </IconWrap>
          <Title>{title}</Title>
          <Intro style={{ fontSize: "15px" }}>{message}</Intro>
        </Content>

        <BottomCard>
          <ModalButton color={color} secondary={false} onClick={onClose}>
            {acknowledgeLabel}
          </ModalButton>
        </BottomCard>
      </div>
    </StyledPopup>
  );
};

export default MarcaBlancaTamperModal;
